module.exports = __webpack_public_path__ + "img/MaurerEFZ-JM-1635.36ba7fd8.jpg";